export type ResourceCardType = 'article' | 'successStory' | 'event' | 'guide' | 'collection';

type BaseSearchPredicatesByCustomType = Record<string, {predicates?: string[]}>;

const RESOURCE_CARD_TYPES = new Set<string>(['article', 'successStory', 'event', 'guide', 'collection']);

const RESOURCE_TYPE_MAP: Partial<Record<string, string>> = {
    articles: 'article',
    collections: 'collection',
    events: 'event',
    guides: 'guide',
    'success-stories': 'successStory',
};

export function getResourceListCardType(type: string): ResourceCardType | null {
    return RESOURCE_CARD_TYPES.has(type) ? (type as ResourceCardType) : null;
}

export function getResourceListPrismicType(resourceType: string): string | null {
    return RESOURCE_TYPE_MAP[resourceType] ?? null;
}

export function getResourceListBasePredicates(prismicType: string, baseSearchPredicatesByCustomType: BaseSearchPredicatesByCustomType) {
    return prismicType in baseSearchPredicatesByCustomType ? (baseSearchPredicatesByCustomType[prismicType].predicates ?? []) : [];
}
